import { Link } from "react-router-dom";
import { ArrowUpRight } from "lucide-react";
import { Reveal } from "./Reveal";
import { FlagChip } from "./icons";

const STATUS_STYLE = {
  Available: "bg-tosca-500/90 text-white",
  Limited: "bg-gold/90 text-charcoal",
  "Sold Out": "bg-red-500/90 text-white",
  "Coming Soon": "bg-white/80 text-slate-600",
};

export function StatusChip({ status, testid }) {
  return (
    <span data-testid={testid || "status-chip"} className={`chip ${STATUS_STYLE[status] || "bg-white/80 text-slate-600"}`}>
      {status}
    </span>
  );
}

export default function DestinationCard({ destination, index = 0, wide = false }) {
  const d = destination;
  return (
    <Reveal delay={Math.min(index * 0.06, 0.3)} className="h-full">
      <Link
        to={`/destinations/${d.slug}`}
        data-testid={`destination-card-${d.slug}`}
        className="group relative block h-full overflow-hidden rounded-3xl shadow-crystal card-hover"
      >
        <div className={`relative ${wide ? "aspect-[16/10]" : "aspect-[3/4] sm:aspect-[4/5]"}`}>
          <img
            src={d.hero_image}
            alt={`${d.name} Land Arrangement`}
            loading={index > 2 ? "lazy" : "eager"}
            decoding="async"
            className="absolute inset-0 h-full w-full object-cover transition-transform duration-700 ease-out group-hover:scale-110"
          />
          <div className="absolute inset-0 bg-gradient-to-t from-black/85 via-black/25 to-black/10 transition-opacity duration-500" />
        </div>

        <div className="absolute inset-x-0 top-0 flex items-start justify-between p-4">
          <FlagChip code={d.flag} />
          <StatusChip status={d.status} testid={`destination-status-${d.slug}`} />
        </div>

        <div className="absolute inset-x-0 bottom-0 p-5">
          <p className="text-[11px] font-semibold uppercase tracking-[0.2em] text-gold">{d.region}</p>
          <h3 className="mt-1 font-heading text-2xl font-extrabold text-white">{d.name}</h3>
          <p className="mt-1.5 clamp-2 text-xs leading-relaxed text-white/75">{d.short_desc}</p>
          <span className="mt-3 inline-flex items-center gap-1.5 text-xs font-bold uppercase tracking-[0.18em] text-gold">
            Explore
            <ArrowUpRight className="h-4 w-4 transition-transform duration-300 group-hover:translate-x-1 group-hover:-translate-y-1" />
          </span>
        </div>
      </Link>
    </Reveal>
  );
}
